const SectionsMap = {
  'final': 'Overall',
  'hours_investment_fees': 'Hours, Invesment and Fees',
  'review_comments': 'Review Comments',
  'ecr_client_acceptance': 'ECR - Client Acceptance',
  'independence': 'Independence',
  'engagement_acceptance': 'Engagement Acceptance',
  'higher_risk_engagements': 'Higher Risk Engagements',
  'contracting': 'Contracting',
  'deliverables_and_disclaimers': 'Deliverables and Disclaimers',
  'documentation': 'Documentation',
  'performance_and_review': 'Performance and Review',
  'record_of_work_performed': 'Record of work performed',
  'client_acceptance': 'Client Acceptance',

  'clear_scope': 'Clear scope',
  'engaged_stakeholders': 'Engaged stakeholders',
  'governance_enabled': 'Governance enabled decision making',
  'focused_benefits_management': 'Focused benefits management',
  'managed_risks': 'Managed risk and opportunities',
  'smart_financing': 'Smart financing',
  'delivery_enabling_plans': 'Delivery-enabling plans',
  'active_quality': 'Active quality management',
  'agile_change_control': 'Agile change control',
  'integrated_suppliers': 'Integrated suppliers (and clients)',
  'high_performing_teams': 'High performing teams',
  'embedded_lifecycle': 'Embedded lifecycle assurance and learning',
}

export default section => SectionsMap[section] || 'Section not mapped yet'
